<template>
    <div class="news-card" :class="index % 2 ? 'odd' : 'even'">
        <img :src="article.image"/>
        <div class="content">
            <a :href="article.link"><h1>{{article.title}}</h1></a>
            <div class="body" style="margin-bottom: 20px;">"<i>{{ article.body }}</i>"</div>
            <div style="text-align: right"><a class="button" target="_blank" :href="article.link">Read More</a></div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['article', 'index']
}
</script>

<style lang="scss">
.button {
    font-family: Teko;
    font-size: 1.5em;
    width: 30%;
    padding: 5px;
    border: 3px solid white;
    margin-top: 10px;
    margin-left: 15px;
    margin-right: 15px;
    color: #333333;
    &:hover {
        cursor: pointer;
    }
}

.news-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    width: 100%;
    font-family: 'Nunito Sans';
    font-weight: bold;
    text-align: left;
    .body {
        margin-bottom: 20px;
        color: #333;
    }
    h1 {
        font-family: 'Nunito Sans';
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 10px;
    }
    img { 
        width: 100%; 
    }
    &.even {
        .content {
            background: #97d3ce;
            .button {
                background: #97d3ce;
            }
        }
    }
    &.odd {
        .content {
            background: #d8c6e4;
            .button {
                background: #d8c6e4;
            }
        }
    }
    .content {
        width: 100%;
        padding: 5%;
    }
}
@media (min-width: 1030px) {
    .news-card {
        flex-direction: row;
        width: 100%;
        margin-bottom: 100px;
        &.even {
            img {
                border: 3px solid #d8c6e4;
            }
        }
        &.odd {
            img {
                border: 3px solid #97d3ce;
            }
            .content {
                order: -1;
            }
        }
        .content {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            height: 400px;
            width: 50%;
            padding: 2%;
        }
        img {
            width: 65%;
        }
    }
}
</style>
